import { render } from "./addPosition.vue?vue&type=template&id=621c3e84&scoped=true"
import script from "./addPosition.vue?vue&type=script&lang=js"
export * from "./addPosition.vue?vue&type=script&lang=js"

import "./addPosition.vue?vue&type=style&index=0&id=621c3e84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621c3e84"]])

export default __exports__